import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Important Papers initial values
export const importantPapersInitialValues = {
  category: "",
  issuingAuthority: "",
  documentNumber: "",
  issueDate: "",
  expiryDate: "",
  linkedAsset: "",
  ownershipType: "",
  purchaseDate:"",
  purchasePrice:"0",
  documentStatus: "",
  documentType: "",
  storageLocation: "",
}

// Important Papers validation schema
export const importantPapersValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Document Name is required")
    .min(3, "Min length: 3 characters")
    .max(50, "Max length: 50 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  // purchaseDate: Yup.string().required("Purchase Date is required"),
  // purchasePrice: Yup.number()
  //   .typeError("Must be a positive number")
  //   .required("Purchase price/amount is required")
  //   .positive("Must be a positive number > 0")
  //   .min(1, "Value must be 1 or greater"),
  category: Yup.string().required("Document Category is required"),
  issuingAuthority: Yup.string()
  .matches(
    /^[A-Za-z\s.&-]+$/,
    "Use only letters, spaces, and characters like . & -"
  ),
  ownershipType: Yup.string().required("Ownership Type is required"),
  issueDate: Yup.string()
    .nullable()
    .test(
      "valid-issue-date",
      "Invalid issue date",
      (value) => {
        if (!value) return true;
        return !isNaN(new Date(value).getTime());
      }
    )
    .test(
      "not-in-future",
      "Issue date cannot be in the future",
      (value) => {
        if (!value) return true;
        return new Date(value) <= new Date();
      }
    ),
  expiryDate: Yup.string()
    .nullable()
    .test(
      "valid-expiry-date",
      "Invalid expiry date",
      (value) => {
        if (!value) return true;
        return !isNaN(new Date(value).getTime());
      }
    )
    .test(
      "after-issue-date",
      "Expiry date must be after issue date",
      function (value) {
        const { issueDate } = this.parent;
        if (!value || !issueDate) return true;
        const issue = new Date(issueDate);
        issue.setDate(issue.getDate() + 1);
        return new Date(value) >= issue;
      }
    ),
  documentNumber: Yup.string().matches(
    /^[A-Za-z]+(?: [A-Za-z]+)*$/,
    "Only alphabets allowed. No numbers or special characters. No space at start or end."
  ),
})

/**
 * Important Papers Form - Field-only component for AddAssets.js
 * This renders only the important-papers-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const ImportantPapersForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting (though not used for this form type)
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="important-papers"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default ImportantPapersForm
